import { render } from "./HelloWorld.vue?vue&type=template&id=11175922&scoped=true&ts=true"
import script from "./HelloWorld.vue?vue&type=script&lang=ts"
export * from "./HelloWorld.vue?vue&type=script&lang=ts"

import "./HelloWorld.vue?vue&type=style&index=0&id=11175922&scoped=true&lang=scss"

import exportComponent from "/home/runner/work/ws-frontend-join/ws-frontend-join/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11175922"]])

export default __exports__